module.exports = __webpack_public_path__ + "static/media/van side left.3536fa32.png";